<template>
  <Popover 
    v-model="visible" 
    popper-class="qrcode-view-popper" 
    width="240" 
    :visible-arrow="false" 
    trigger="hover" 
    transition="el-zoom-in-top"
    @show="onShow"
  >
    <div class="qrcode-area">
      <div class="qrcode-wrapper">
        <img id="qrcode" class="qrcode-img" alt="qrcode" :src="dataUrl" />
      </div>
      <span class="qrcode-tip">扫描二维码查看移动端效果</span>
      <div class="link-box">
        <div class="link-text">{{ url }}</div>
        <copy-btn class="copy-btn" :copy-text="url" />
      </div>
    </div>
    <div slot="reference" class="qrcode-reference">
      <im-icon icon="icon-QrCode" class="text-[20px]" />
    </div>
  </Popover>
</template>

<script>
import { Popover } from 'element-ui'
import QrCode from 'qrcode'
import { generatePreviewUrl } from "~/site/model/helper";
export default {
  name: 'QrcodeView',
  components: {
    Popover
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      visible: false,
      url: '',
      dataUrl: ''
    }
  },
  methods: {
    onShow() {
      const that = this
      this.url = generatePreviewUrl(that, 15)
      const options = {
        margin: 3,
        type: 'image/jpeg'
      }
      QrCode.toDataURL(this.url, options,(err, res) => {
        if (res) {
          this.dataUrl = res
        } else {
          throw new Error(err)
        }
      });
    }
  }
}
</script>

<style lang="less">
.qrcode-view-popper {
  background: rgba(30, 30, 35, 0.95) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4) !important;
  border-radius: 12px !important;
  padding: 20px !important;
  width: 240px !important;

  .qrcode-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--text-light-color);

    .qrcode-wrapper {
      padding: 8px;
      background: #fff;
      border-radius: 8px;
      margin-bottom: 16px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      
      .qrcode-img {
        width: 140px;
        height: 140px;
        display: block;
      }
    }

    .qrcode-tip {
      font-size: 13px;
      margin-bottom: 16px;
      color: rgba(255, 255, 255, 0.7);
    }

    .link-box {
      width: 100%;
      height: 36px;
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 0 8px;
      box-sizing: border-box;
      transition: all 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.08);
        border-color: rgba(255, 255, 255, 0.15);
        
        .link-text {
          color: #fff;
        }
      }

      .link-text {
        flex: 1;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.5);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 8px;
        transition: color 0.2s;
      }

      .copy-btn {
        opacity: 0.8;
        cursor: pointer;
        transition: opacity 0.2s;
        
        &:hover {
          opacity: 1;
        }
      }
    }
  }
}

.qrcode-reference {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-light-color);
  margin-right: 12px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.3);
    color: #fff;
    transform: translateY(-1px);
  }

  .icon {
    width: 18px;
    height: 18px;
    fill: currentColor;
    display: block; // 确保是块级元素，避免行内元素的间隙问题
    object-fit: contain; // 确保内容完整显示
  }
}
</style>
